import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { SessionStorageService } from '../storage/session-storage.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly storageKey = 'previousUrl';
  private currentUrl: string | null = null;
  private isFirstNavigation = true;
  public ipAddress: string = '';

  constructor(
    private readonly router: Router,
    private readonly sessionStorageService: SessionStorageService
  ) {
    this.init();
    this.getClientIp().subscribe();
  }

  private init(): void {
    this.currentUrl = this.router.url;
    this.router.events.pipe(
      startWith(new NavigationEnd(0, this.router.url, this.router.url)),
      filter(event => event instanceof NavigationEnd)
    )
      .subscribe((event: NavigationEnd) => {
        if (this.isFirstNavigation) {
          this.isFirstNavigation = false;
          return;
        }
        if (this.currentUrl) {
          this.sessionStorageService.saveEncryptData(this.storageKey, this.currentUrl);
        }
        this.currentUrl = event.url;
      });
  }

  getPreviousUrl(): string | null {
    return this.sessionStorageService.getEncryptData(this.storageKey);
  }

  getClientIp(): Observable<string> {
    return new Observable<string>((observer) => {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then((data) => {
          this.ipAddress = data.ip;
        })
        .catch((error) => {
          console.error('Error fetching IP:', error);
        });
    });
  }
}
